module.exports = __webpack_public_path__ + "static/img/theme.9b27f2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/friends/theme.png
// module id = Lims
// module chunks = 0